import { Component, OnInit } from '@angular/core';
import { RefundStatusRs } from '../../models/RefundStatusRs';
import { DataService } from '../../services/utils/data.service';
import { TranslatorService } from 'src/app/modules/translator/providers/translator.service';
import { InterpolationService } from 'src/app/services/utils/interpolation.service';

@Component({
  selector: 'app-refund-status-not-refunded',
  templateUrl: './refund-status-not-refunded.component.html',
  styleUrls: ['./refund-status-not-refunded.component.css']
})
export class RefundStatusNotRefundedComponent implements OnInit {

  refundStatusRs: RefundStatusRs;
  // public translations: any;
  public pageData: any;

  isEmailPresent: boolean;

  constructor(private dataService: DataService,
              private translatorService: TranslatorService,
              private interpolatorService: InterpolationService) { }

    public isBeforeCutoffDate(refundIssueDate): boolean {
        return this.dataService.isBeforeCutoffDate(refundIssueDate);
    }

  ngOnInit() {
    this.getPageData();
    this.isEmailPresent = false;
    console.log('loaded pagedata now setting isEmailPresent flage');
    this.dataService.refundStatusRs.subscribe(
        (refundStatusRs) => {
        console.log('dataService.refundStatusRs triggered');
        this.refundStatusRs = refundStatusRs;
        if (this.refundStatusRs.refundStatus[0].passengerContact.email
            && this.refundStatusRs.refundStatus[0].passengerContact.email.trim().length > 0) {
            this.isEmailPresent = true;
            console.log('Updated isEmailPresent to true');
        }
        },
        error => {
        },
        () => {
        // finally
        });
  }

  private getPageData() {
    const dataSet = new Map();
    this.pageData = this.interpolatorService
                        .interpolate(this.translatorService
                                    .getTranslations('refund-status'),
                                    dataSet);

  }

}
